export default __webpack_public_path__ + "static/media/something-went-wrong.b7eda1ee.svg";